/**
 * ProductTriman Component
 */
//jshint ignore:start
(function () {

    'use strict';

    /**
     * Product with Triman attribute
     */
    var ItxProductTrimanCmp = {
        bindings: {
            product: '<'
        },
        controller: ItxProductTrimanCmpCtrl,
        controllerAs: 'productTrimanCtrl',
        template: [
            '<div class="product-triman" ng-if="::productTrimanCtrl.hasTrimanAttr">',
            '<p><i class="icon icon-triman"></i><span ng-bind="::productTrimanCtrl.text"></span></p>',
            '</div>'
        ].join('')
    };

    ItxProductTrimanCmpCtrl.$inject = ['ItxTranslateSvc'];
    
    function ItxProductTrimanCmpCtrl(ItxTranslateSvc) {
        var _this = this;
       
        _this.$onInit = function () {
            if(!_this.product){return;}
            _this.text = ItxTranslateSvc.translateCms('legacy.ItxProductView.trimanText');
            _this.hasTrimanAttr = _.find(_this.product.attributes, function (attr) {
                return attr.name.toLowerCase() === 'triman' && inditex.iCountryCode === 'FR';
            });
        }
    }

    /** Public */
    angular.module('itxApp.catalog')
        .component('itxProductTriman', ItxProductTrimanCmp);

})();
